import LoginForm from './LoginForm.js';

export default LoginForm;
